import React from 'react';
import { Helmet } from "react-helmet-async";
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';

function HeroSection() {
  return (
    <div className='hero-container'>
      <Helmet>
        <title>Veterinarska praksa Zagreb | Dr. Pezo</title>
        <meta 
          name="description" 
          content="Specijalistička veterinarska praksa Dr. Pezo u Zagrebu. Stručna skrb za male životinje. Ultrazvuk, dijagnostika i kirurgija."
        />
        <meta 
          name="keywords" 
          content="veterinar zagreb, veterinarska praksa zagreb, dr pezo, veterinar za male životinje"
        />
        
        <meta property="og:title" content="Veterinarska praksa Zagreb | Dr. Pezo" />
        <meta property="og:description" content="Specijalistička skrb za male životinje u Zagrebu." />
        <meta property="og:type" content="website" />
      </Helmet>
      
      <div className="logo-container">
        <img
            alt=""
            src="/images/grupnaVanka.jpg" 
        />
      </div>

      <h1>Veterinarska praksa Zagreb – Dr. Pezo</h1>

      <p>
        Specijalistička veterinarska praksa za  male životinje u Zagrebu
      </p>

      <div className='hero-btns'>
        <div className="btn-wrapper">
          <Button
            className='btns'
            buttonStyle='btn--outline'
            buttonSize='btn--large'
            to='/usluge'
          >
            Veterinarske usluge
          </Button>
        </div>

        <div className="btn-wrapper">
          <Button
            className='btns'
            buttonStyle='btn--primary'
            buttonSize='btn--large'
            to='/kontakt'
          >
            Kontakt
          </Button>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;